document.addEventListener('DOMContentLoaded', function() {
  const threadSwiper = document.querySelector('.thread-images-swiper');

  if (threadSwiper) {
    new Swiper('.thread-images-swiper', {
      slidesPerView: 'auto',
      spaceBetween: 0,
      pagination: {
        el: '.thread-swiper-progress',
        type: 'progressbar',
      },
      loop: false,
      speed: 600,
      simulateTouch: true,
      touchRatio: 1,
      mousewheel: {
        enabled: true,
        sensitivity: 1
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },
      rewind: true,
      breakpoints: {
        0: {
          spaceBetween: 9
        },
        750: {
          spaceBetween: 16
        }
      }
    });
  }
});